import validate from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45redirects_45global from "/home/vsts/work/1/s/middleware/01.redirects.global.ts";
import _02_45query_45actions_45global from "/home/vsts/work/1/s/middleware/02.query-actions.global.ts";
import general_45global from "/home/vsts/work/1/s/middleware/general.global.ts";
import scroll_45global from "/home/vsts/work/1/s/middleware/scroll.global.ts";
import update_45personalised_45global from "/home/vsts/work/1/s/middleware/update-personalised.global.ts";
export const globalMiddleware = [
  validate,
  _01_45redirects_45global,
  _02_45query_45actions_45global,
  general_45global,
  scroll_45global,
  update_45personalised_45global
]
export const namedMiddleware = {
  "auth-logged-in": () => import("/home/vsts/work/1/s/middleware/auth-logged-in.ts"),
  "big-city-life": () => import("/home/vsts/work/1/s/middleware/big-city-life.ts"),
  "demo-play": () => import("/home/vsts/work/1/s/middleware/demo-play.ts")
}